export const USER_GROUPS = "/api/groups"
export const USER_GROUP = "/api/group/:param"
